export default "__VITE_ASSET__e7c11797__"